import { render, staticRenderFns } from "./expertLiterature.vue?vue&type=template&id=362dd42a&scoped=true"
import script from "./expertLiterature.vue?vue&type=script&lang=js"
export * from "./expertLiterature.vue?vue&type=script&lang=js"
import style0 from "./expertLiterature.vue?vue&type=style&index=0&id=362dd42a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "362dd42a",
  null
  
)

export default component.exports